import React from 'react';
import { Fab, Box, Tooltip, Zoom, useTheme } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export const AIAssistantWidget = () => {
    const theme = useTheme();

    // Placeholder function for opening the full AI chat
    const handleOpenAI = () => {
        console.log("Opening AI Assistant Chat Modal/Panel");
    };

    return (
        // Box for positioning the widget (bottom-right)
        <Box
            sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 1000, // Ensure it floats above other content
            }}
        >
            <Tooltip 
                title="AI Assistant: Guidance & Support" 
                placement="left" 
                arrow
                TransitionComponent={Zoom}
            >
                <Fab 
                    color="primary" 
                    aria-label="ai assistant" 
                    onClick={handleOpenAI}
                    sx={{ 
                        width: 64, 
                        height: 64,
                        bgcolor: theme.palette.secondary.main, // Use secondary color for emphasis
                        '&:hover': {
                            bgcolor: theme.palette.secondary.dark,
                        }
                    }}
                >
                    <SmartToyIcon sx={{ fontSize: 32 }} />
                </Fab>
            </Tooltip>
        </Box>
    );
};